import React from 'react'
import {
  Box,
  makeStyles,
  Typography,
} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    paddingBottom: theme.spacing(1.5),
    '& h2': {
      // room for close button
      marginRight: theme.spacing(4),
      marginBottom: theme.spacing(1.5),
    },
  },
}))

const LegendChartHeaders = ({ title, subtitle }) => {
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      <Box>
        <Typography variant="h2">{title}</Typography>
      </Box>
      <Box>
        <Typography
          variant="body1"
          className="chart-subtitle"
        >
          {subtitle}
        </Typography>
      </Box>
    </Box>
  )
}

LegendChartHeaders.defaultProps = {}

export default LegendChartHeaders
